import EscrevaComponent from './escreva.component'

export default EscrevaComponent
